( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('PricingCustomService', PricingCustomService);

    PricingCustomService.$inject = ['$http'];

    function PricingCustomService( $http ) {
        return {
            getFixationsByPricing: getFixationsByPricing
        };
        function getFixationsByPricing( id ) {
            var url = "api/pricings/"+id+"/fixations";
            return $http.get( url );
        }
    }
})();
